/* Web-only globals. Keyboard focus wears the brand ring (tokens.focusRing)
   everywhere instead of the browser/OS default outline. Text inputs own
   their focus look (border + glow set in-component), so they opt out. */
html,
body {
  background: #0d0e14;
  min-height: 100%;
}

#root {
  background: transparent;
  min-height: 100%;
  position: relative;
}

:focus-visible {
  outline: 2px solid rgba(143, 168, 250, 0.55);
  outline-offset: 2px;
}

input:focus-visible,
textarea:focus-visible {
  outline: none;
}

/* Hover easing is decorative. People who reduce motion still receive the
   final hover color and immediate pressed/focus feedback, without a tween. */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0s !important;
  }
}

/* Minimal canvas: hide the persistent desktop scrollbar. Content stays fully
   scrollable (wheel, trackpad, touch), and mobile web keeps its own native
   overlay scroll indicator, which the OS draws regardless of this rule.
   Dropping the gutter also realigns the watch page's fixed header with the
   content that scrolls beneath it. */
* {
  scrollbar-width: none; /* Firefox */
}
*::-webkit-scrollbar {
  display: none; /* Chromium, Safari */
}

/* The web player's skin is ejected and lives in
   playback/players/skin/player-skin.css — edit structure and styles there
   directly instead of overriding it from here. */
